<template>
    <div>
        <MqLayout mq="md+">
            <SearchResults />
        </MqLayout>
        <MqLayout :mq="['sm', 'tsm']">
            <SearchResultsMobile />
        </MqLayout>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import Cookie from '@/services/cookie';

    import SearchResults from '@/apps/search/001/components/SearchResults';
    import SearchResultsMobile from '@/apps/search/001/components/SearchResultsMobile';

    export default {
        name: 'SearchResultsWrapper',

        components: {
            SearchResults,
            SearchResultsMobile,
        },

        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),
        },

        async created() {
            if (Cookie.getToken()) {
                await this.$_getMe().then(() => {
                    this.$_getJobEvents();
                });
            }

            let search_url = this.$route.params.pathMatch;
            search_url = search_url.replace('-at-', '@').replace('-dot-', '.');

            const params = search_url.split('/');

            let page = 1;
            params.forEach(p => {
                if (p.indexOf('page') >= 0) {
                    const _pages = p.split('_');
                    page = _pages[1];
                }
            });

            const input = {
                url: search_url,
                facet: 1,
                allow_backfill: true,
                page: page,
            };

            await this.$_searchJobsByUrl(input)
                .then(response => {
                    Cookie.setJobFilter(search_url);
                    this.$_SET_OBJECT({ key: 'searchPayload', value: response });
                })
                .catch(e => {
                    if (
                        e.name === 'TypeError [ERR_UNESCAPED_CHARACTERS]' ||
                        e.response.status === 404 ||
                        e.response.status === 422
                    ) {
                        const url = '/not-found/';
                        window.location.href = url;
                    }
                })
                .finally(() => {
                    this.$_SET_LOADING_JOBS(false);
                });
        },

        methods: {
            ...mapMutations('classification', {
                $_SET_CLASSIFICATIONS: 'SET_CLASSIFICATIONS',
            }),

            ...mapActions('classification', {
                $_getClassifications: 'getSeekerClassifications',
            }),

            ...mapMutations('search', {
                $_SET_LOADING_JOBS: 'SET_LOADING_JOBS',
                $_SET_OBJECT: 'SET_OBJECT',
            }),

            ...mapActions('me', {
                $_getMe: 'getMe',
                $_getJobEvents: 'getJobEvents',
            }),

            ...mapActions('search', {
                $_searchJobsByUrl: 'searchJobsByUrl',
            }),
        },
    };
</script>
